import { HeroTeaser } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";

export const MaintenancePage = () => {
    const { t } = useTranslation("maintenance");
    return (
        <HeroTeaser
            noImage
            sub={
                <>
                    <p>{t("maintenance:text1")}</p>
                    <p>{t("maintenance:text2")}</p>
                </>
            }
            title={t("maintenance:title")}
        />
    );
};
